import { gql } from "@apollo/client";
export const SaveUserPreferences = gql`
  mutation CreateUserView(
    $userView: UserView!
  ) {
    CreateUserView(
      userView: $userView
    ) {
      id
    }
  }
`;
